import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import clsx from 'clsx';
import {
  Tab as ReachTab,
  TabList,
  TabPanel,
  TabPanels,
  TabProps as ReachTabProps,
  Tabs
} from '@reach/tabs';

import '@reach/tabs/styles.css';
import styles from './Tabs.module.scss';

export type TabProps<T extends ElementType> = ReachTabProps & {
  isSelected?: boolean;
  className?: string;
  as?: T;
};

export const Tab = <T extends ElementType = 'button'>({
  as,
  children,
  className,
  ...props
}: TabProps<T> & Omit<ComponentPropsWithoutRef<T>, keyof TabProps<T>>) => {
  return (
    <ReachTab
      {...props}
      as={as as React.ComponentProps<T> | undefined}
      className={clsx(
        styles.tab,
        {
          [styles.tabSelected as string]: props.isSelected
        },
        className
      )}
    >
      {children}
    </ReachTab>
  );
};

// Exports our custom Tabs component along with the default reach-ui tab and panel components.
export { Tabs, TabList, TabPanels, TabPanel };
export { type TabsProps } from '@reach/tabs';
